import React from 'react'
import { File } from '@ow/comps'
import clsx from 'clsx'
import { StyledFileList, StyledFileDetail } from './styled'
import viewSlugMap from '../utils/viewSlugMap'

const FileList = ({
  tbData,
  fileMap,
  fileConfig,
  onClickdownload,
  onClickdownloadIcon,
  showDelete,
  onClickDelete,
}) => {
  return fileConfig.type === 'iconlist' ? (
    <StyledFileList>
      {tbData &&
        tbData.map((item) => {
          const props = viewSlugMap(fileMap || {}, item)
          return (
            <File
              key={props.key}
              showDelete={showDelete}
              onClickDelete={() => {
                onClickDelete(props.key && props.key)
              }}
              downloadIcon={fileConfig.downloadicon}
              type="iconlist"
              media={props.media && props.media[0]}
              briefingName={props.briefingName || ''}
              datetime={props.dataInterval || ''}
              onClickdownloadIcon={() => {
                onClickdownloadIcon(props.media.length ? props.media : [])
              }}
            />
          )
        })}
    </StyledFileList>
  ) : (
    <StyledFileDetail>
      {tbData &&
        tbData.map((item, i) => {
          const props = viewSlugMap(fileMap || {}, item)
          return (
            <File
              type="list"
              className={clsx('list-item', {
                'item-width': i,
                'w-full': i === 0,
              })}
              media={props.media && props.media[0]}
              datetime={props.datetime || ''}
              briefingName={props.briefingName || ''}
              shortConSlateRichText={props.shortConSlateRichText || ''}
              content={props.content || ''}
              listIndex={i}
              onClickdownload={() => {
                onClickdownload(props.media.length ? props.media[0].src : '')
              }}
            />
          )
        })}
    </StyledFileDetail>
  )
}

export default FileList
